import { Dialog, DialogContent, DialogTitle } from "@workspace/web-ui/components/dialog";
import { PrescriptionForm } from "../form/prescription-form";

interface PrescriptionModalProps {
    open: boolean;
    patientId: string;
    onOpenChange: (open: boolean) => void;
    encounterId?: string;
    refillId?: string;
    prescriptionId?: string;
}


export const PrescriptionModal = ({ open, onOpenChange, patientId, encounterId, refillId, prescriptionId}: PrescriptionModalProps) => {
    const handleClose = () => {
        onOpenChange(false);
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="h-[90vh] xl:h-[95vh] flex flex-col p-0 hide-scrollbar">
                <DialogTitle></DialogTitle>
                <PrescriptionForm 
                    patientId={patientId} 
                    encounterId={encounterId || ""} 
                    refillId={refillId || ""} 
                    prescriptionId={prescriptionId || ""}
                    onClose={handleClose}
                />
            </DialogContent>
        </Dialog>
    )
}